import { render, staticRenderFns } from "./CheckoutStripeButton.vue?vue&type=template&id=40ba89ea&"
import script from "./CheckoutStripeButton.vue?vue&type=script&lang=js&"
export * from "./CheckoutStripeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports